export const Resources = {
  // WORK_OBJECT_MANAGER: 'WORK_OBJECT_MANAGER',
  BOT_MANAGER: 'BOT_MANAGER',
  CATEGORY_MANAGER: 'CATEGORY_MANAGER',
  DB_MANAGER: 'DB_MANAGER',
  USER_MANAGER: 'USER_MANAGER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  REPORT_VIEW: 'REPORT_VIEW',
  TEMPLATE_VIEW: 'TEMPLATE_VIEW',
};

const resources = [
  {
    name: 'Gerenciar bots',
    description: 'Permite membros gerenciar os bots.',
    id: Resources.BOT_MANAGER,
    default_value: true,
  },
  // {
  //   name: 'Gerenciar objetos de trabalho',
  //   description: 'Permite membros gerenciar os objetos de trabalho dos bots.',
  //   id: Resources.WORK_OBJECT_MANAGER,
  //   default_value: false,
  // },
  {
    name: 'Gerenciar Banco de dados',
    description: 'Permite membros gerenciar (criar, atualizar e remover) os bancos de dados.',
    id: Resources.DB_MANAGER,
    default_value: false,
  },
  {
    name: 'Gerenciar Membros',
    description: 'Permite membros gerenciar (convidar, adicionar papéis e remover) outros membros.',
    id: Resources.USER_MANAGER,
    default_value: false,
  },
  {
    name: 'Gerenciar Papéis',
    description: 'Permite membros gerenciar (criar, atualizar e remover) papéis.',
    id: Resources.ROLE_MANAGER,
    default_value: false,
  },
  {
    name: 'Gerenciar Setores',
    description: 'Permite membros gerenciar (criar, atualizar e remover) setores.',
    id: Resources.CATEGORY_MANAGER,
    default_value: false,
  },
  {
    name: 'Visualizar Relatórios',
    description: 'Permite membros visualizar os relatórios.',
    id: Resources.REPORT_VIEW,
    default_value: false,
  },
];

export default class ResourceHelper {
  static Resources = Resources;
  static all() {
    return resources;
  }
}
